<template>
  <AppWithLoading v-slot:default="{loader}">
    <div @click="loader(()=>save())" class="payment-method-item-add">
      <div class="payment-method-item-add__wrap">
        <div class="payment-method-item-add__icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0" /><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" /><g id="SVGRepo_iconCarrier"> <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
            fill="#C4C4C4"
          /> </g></svg>
        </div>
        <div class="payment-method-item-add__name">
          <div>
            {{ $t('add') }}
          </div>
        </div>
      </div>
    </div>
  </AppWithLoading>
</template>

<script>
import AppWithLoading from '@/components/AppWithLoading';
import { ref, toRefs } from '@vue/composition-api';
import useAlfabank from '@/compositions/accounting/useAlfabank';

export default {
  name: 'PaymentMethodCardAlfabankAdd',
  components: { AppWithLoading },
  props: {
    trialPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const { trialPage } = toRefs(props);
    const error = ref(null);
    const date = ref(Date.now());
    const { createPaymentMethod } = useAlfabank();

    async function save() {
      const result = await createPaymentMethod();
      if (trialPage.value) {
        localStorage.setItem('redirect_on_trial_page', true);
      }
      if (result && result.redirect) {
        document.location.href = result.redirect;
      }
    }

    return {
      save,
      error,
      date,
    };
  },
};
</script>

<style lang="scss" scoped>
  .payment-method-item-add {
    border: 1px dashed #E0E0E0;
    border-radius: 0.5rem;
    font-size: 1.0625rem;
    font-weight: 400;
    line-height: 1.53;
    color: #091A35;
    position: relative;
    margin-bottom: 1.25rem;
    display: flex;
    align-items: center;
    min-height: 100px;
    padding: 0 1.5rem;
    cursor: pointer;
    &__wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4.0625rem;
      height: 3.25rem;
      border: 1px solid #EEEEEE;
      border-radius: 0.5rem;
      line-height: 0;
      margin-right: 27px;
      svg {
        width: 36px;
      }
    }
  }
</style>

<i18n lang="yml" locale="ru">
add: Добавить карту
</i18n>
<i18n lang="yml" locale="en">
add: Add card
</i18n>
